import { api } from '@/api/index'

const user = {
  state: {
    isLogin: false,
    accountInfo: null,
    token: ''
  },
  mutations: {
    SET_LOGIN: (state, isLogin) => {
      state.isLogin = isLogin
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ACCOUNT_INFO(state, accountInfo) {
      state.accountInfo = accountInfo
    }
  },
  actions: {
    // 登录
    Login({commit}, account) {
      return new Promise((resolve, reject) => {
        api.login({
          agentAccount: account.username,
          pwd: account.password
        }).then(response => {
          const token = response.data
          commit('SET_TOKEN', token)
          commit('SET_ACCOUNT_INFO', '1111')
          commit('SET_LOGIN', true)
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ACCOUNT_INFO', '')
        commit('SET_LOGIN', false)
        resolve()
      })
    }
  }
}

export default user